import React from 'react';
import { Link } from '../../atoms/Link';
import { Image } from '../../atoms/Image';
import type { AssetImport } from '../../helpers/assetSrc';
import './SubNavItem.css';

export interface SubNavItemProps {
  label: string;
  href: string;
  description: string;
  /**
   * Icon. Accepts a URL string (webpack/UMD) or a static-import object
   * (Next/Turbopack). Normalisation happens inside the Image atom.
   */
  icon?: AssetImport;
  badgeText?: string;
  badgeColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const SubNavItem: React.FC<SubNavItemProps> = ({
  label,
  href,
  description,
  icon,
  badgeText,
  badgeColor,
  className = '',
  style,
}) => {
  return (
    <Link
      href={href}
      noUnderline
      className={`hi-ui hi-ui-subnav-item ${className}`.trim()}
      style={style}
    >
      {icon && (
        <div className="hi-ui-subnav-item__icon-container">
          <Image src={icon} alt="" className="hi-ui-subnav-item__icon" />
        </div>
      )}
      <div className="hi-ui-subnav-item__content">
        <div className="hi-ui-subnav-item__label">
          {badgeText && (
            <div className="hi-ui-subnav-item__sale-badge">
              <span className="hi-ui-nav-badge" style={{ backgroundColor: badgeColor }}>
                {badgeText}
              </span>
            </div>
          )}
          <span>{label}</span>
        </div>
        <div className="hi-ui-subnav-item__separator" />
        <div className="hi-ui-subnav-item__description">{description}</div>
      </div>
    </Link>
  );
};
